module.exports = __webpack_public_path__ + "media/images/player-preview-b4e28d2a.png";